var React = require('react');

function ArrowDownSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.31032 9.27589C7.71024 8.89499 8.34322 8.9104 8.72412 9.31032L12 12.7498L15.2759 9.31032C15.6568 8.9104 16.2898 8.89499 16.6897 9.27589C17.0896 9.65679 17.105 10.2898 16.7241 10.6897L13.0388 14.559L13.0229 14.5753C12.8888 14.7099 12.7294 14.8167 12.5538 14.8896C12.3783 14.9625 12.1901 15 12 15C11.8099 15 11.6217 14.9625 11.4462 14.8896C11.2706 14.8167 11.1112 14.7099 10.9771 14.5753L10.9612 14.559L7.27589 10.6897C6.89499 10.2898 6.9104 9.65679 7.31032 9.27589Z","fill":"currentColor"}));
}

ArrowDownSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowDownSmall;

ArrowDownSmall.default = ArrowDownSmall;
